<template>
  <router-view/>
  <div class="sp-model" v-show="showsp">
    <div class="sp-div">
    </div>
  </div>
    <div class="sp-form" v-show="showsp">
        <div class="sp-big2" v-if="next_change_need">您已超过60天没有改过密码了，请前往小程序管理端财务页面修改密码</div>
        <div class="sp-big" v-else>屏幕已锁定</div>
        <!-- <div class="red mb10" :class="pwderr?'':'opa0'">密码错误</div> -->
        <div class="sp-sml">
            <el-input class="sp-sml-abs" size="large" v-model="pwd" type="text" clearable @keyup.enter="jspm"></el-input>
            <el-input size="large" readonly placeholder="请输入密码解锁" v-model="pwd" type="password"></el-input>
        </div>
        <div class="sp-btn"><el-button :loading="loading" @click="jspm" type="primary" size="large">解&nbsp;&nbsp;&nbsp;锁</el-button></div>
    </div>
</template>
<script setup>
    import { ref, onMounted,computed } from 'vue';
    import { adminCheckpwdApi } from './api';
    import { elMsg } from './utils/message';
    const showsp = ref(false);
    const loading = ref(false);
    const pwderr = ref(false);
    const userinfo = ref({});
    const next_change_need = ref(false);
    const pwd = ref('');
    // 是否开发环境
    const isDevelopment = computed(() => process.env.NODE_ENV === 'development');
    const jspm = () => {
        pwderr.value = false;
        if(pwd.value){
            loading.value = true;
            if(pwd.value.length > 5){
                adminCheckpwdApi({
                    phone: localStorage.getItem('USER'),
                    password: pwd.value
                }).then((result) => {
                    if(result.data.post_id){
                        localStorage.setItem('STAFF', JSON.stringify(result.data))
                        next_change_need.value = false;
                    }
                    pwd.value = '';
                    showsp.value = false;
                    loading.value = false;
                    localStorage.removeItem('is-clock');
                    resetTimer();
                }).catch((err) => {
                    loading.value = false;
                    pwderr.value = true;
                });
            }else{
                setTimeout(() => {
                    elMsg('密码错误','error');
                    pwderr.value = true;
                    loading.value = false;
                }, 500)
            }
        }else{
            elMsg('请输入密码','warning');
        }
    }
    let timeout;

    function resetTimer(e) {
        // 是否需要强制修改密码
        if(e && e.shiftKey && (e.key == 'M' || e.key == 'm')){
            showLockScreen(); // 显示锁定屏幕的函数
            return;
        }
        // console.log(e);
        // console.log('重置');
        clearTimeout(timeout);
        // 设置新的30分钟定时器
        timeout = setTimeout(function() {
            showLockScreen(); // 显示锁定屏幕的函数
        }, 1800000); // 1800000毫秒 = 30分钟
    }

    function showLockScreen() {
        // 显示密码输入框和解锁逻辑
        // && localStorage.getItem('USER') != '13000000000'
        if(localStorage.getItem('TOKEN') && !isDevelopment){
            showsp.value = true;
            localStorage.setItem('is-clock', 1);
        }
    }

    // 初始化定时器
    resetTimer();

    // 监听所有用户事件来重置定时器
    document.addEventListener('click', resetTimer);
    document.addEventListener('keypress', resetTimer);
    document.addEventListener('touchstart', resetTimer); // 对于触摸屏设备
    const checkPwd = () => {
        setInterval(() => {
            if(next_change_need.value){
                showLockScreen();
            }
        }, 3600000)
    }
    
    onMounted(() => {
        userinfo.value = JSON.parse(localStorage.getItem('STAFF') || '{}');
        if(userinfo.value.next_change_time){
            const timese = new Date(userinfo.value.next_change_time.replace(/\-/ig, '/')).getTime();
            if(timese <= Date.now() && userinfo.value.post_id==2){
                next_change_need.value = true;
            }else{
                next_change_need.value = false;
            }
        }else{
            next_change_need.value = false;
        }
        if(localStorage.getItem('is-clock')){
            showLockScreen();
        }
        // 轮训检查密码是否需要强制修改密码
        checkPwd();
    })
</script>
<style>
    .sp-model{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
        background-color: #152C67;
    }
    .sp-div {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .sp-form {
        width: 400px;
        height: 300px;
        background-color: #fff;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 9999;
    }
    .sp-big {
        font-size: 30px;
        margin-top: 40px;
        margin-bottom: 60px;
    }
    .sp-big2{
        font-size: 20px;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    .sp-sml {
        font-size: 20px;
        margin-bottom: 60px;
        position: relative;
    }
    .sp-sml-abs {
        position: absolute !important;
        z-index: 999 !important;
        top: 0;
        left: 0;
    }
    .sp-sml-abs .el-input__wrapper{
        background-color: rgba(0, 0, 0, 0) !important;
    }
    .sp-sml-abs .el-input__inner{
        opacity: 0 !important;
    }
    .sp-btn .el-button{
        width: 200px;
        font-size: 20px;
    }
</style>